/* eslint-disable no-debugger */

import { useState } from 'react';
import { createContainer, useContainer } from 'unstated-next';
import _ from 'lodash';
import { JobOrderBoardDto } from '../../../../../common/dist';
import { useDataProvider } from 'react-admin';
import { JobContainer } from './job';
import {
  EMPTY_MATERIALS,
  INITIAL_DRAFT_PURCHASE_ORDER,
  INITIAL_FLOORS,
  INITIAL_MATERIALS,
} from '../constants';
import { PurchaseOrderFieldsType } from '../types';

const usePurchaseOrder = () => {
  const { selectedPurchaseOrder } = useContainer(JobContainer);

  const dataProvider = useDataProvider();

  const [draftPurchaseOrder, setDraftPurchaseOrder] = useState({
    ...INITIAL_DRAFT_PURCHASE_ORDER,
  });
  const [hasPOBoardExcelFloors, setPOHasBoardExcelFloors] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [jobOrderBoard, setJobOrderBoard] = useState<JobOrderBoardDto[] | null>(
    null,
  );
  const [selectedPhase, setSelectedPhase] = useState('');
  const [isDraft, setIsDraft] = useState(false);
  const [sameSupplier, setSameSupplier] = useState(true);
  const isEdit = selectedPurchaseOrder !== null;
  const isNew = selectedPurchaseOrder === null;
  const isCanceled = isEdit && !isDraft && !!selectedPurchaseOrder?.canceled;

  const resetPurchaseOrder = (
    hasPurchaseOrder: boolean,
    overrides: Partial<PurchaseOrderFieldsType> = {},
  ) => {
    setDraftPurchaseOrder(prevState => ({
      ...prevState,
      boardPurchaseFloors: [...INITIAL_FLOORS],
      materials: hasPurchaseOrder
        ? [...EMPTY_MATERIALS]
        : [...INITIAL_MATERIALS],
      ...overrides,
    }));
  };

  const getJobOrderBoard = async (jobId: string) => {
    const jobOrderBoard = await dataProvider.getList<JobOrderBoardDto>(
      'job-order-board',
      {
        filter: { jobId: jobId },
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'boardTypeShortname', order: 'ASC' },
      },
    );

    if (jobOrderBoard?.data.length) {
      setJobOrderBoard(jobOrderBoard.data);
    }
  };

  return {
    draftPurchaseOrder,
    hasPOBoardExcelFloors,
    isLoading,
    errors,
    jobOrderBoard,
    selectedPhase,
    selectedPurchaseOrder,
    isDraft,
    isEdit,
    isNew,
    isCanceled,
    sameSupplier,
    resetPurchaseOrder,
    setErrors,
    getJobOrderBoard,
    setSelectedPhase,
    setDraftPurchaseOrder,
    setIsLoading,
    setIsDraft,
    setPOHasBoardExcelFloors,
    setSameSupplier,
  };
};

export const PurchaseOrderContainer = createContainer(usePurchaseOrder);
